<script setup>
import {defineEmits, defineModel, defineProps, computed} from 'vue'
import DateRangePicker from 'vue3-daterange-picker'
import 'vue3-daterange-picker/src/assets/daterangepicker.scss'
import dayjs from 'dayjs'
import {authUserDateFormatLowercase} from '@shared/utils/date/date_helpers'

const modelValue = defineModel('modelValue', {required: false})
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  fullDate: {
    type: Boolean,
    default: false,
  },
  timePicker: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['updated'])

const isValid = computed(() => !props.required || !!modelValue.value)
const dateRange = computed(() => {
  return {
    startDate: modelValue.value,
    endDate: modelValue.value,
  }
})

const locale = {
  firstDay: 1,
  format: authUserDateFormatLowercase.value
}

const onChange = val => {
  const date = val?.startDate ?? val
  const format = props.timePicker ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'
  const selected = props.fullDate ? date : dayjs(date).format(format)

  modelValue.value = selected
  emit('updated', selected)
}
</script>

<template>
  <div :class="['the-select-wrapper', isValid ? 'valid' : 'invalid']">
    <input v-if="required && !isValid" class="d-none" required />
    <div :class="disabled || loading ? 'disabled-wrapper' : ''">
      <date-range-picker
        v-model="dateRange"
        ref="picker"
        opens="right"
        :single-date-picker="true"
        @update:startDate="onChange"
        @update:modelValue="onChange"
        :locale-data="locale"
        :auto-apply="true"
        :date-range="dateRange"
        :ranges="false"
        :time-picker="timePicker"
        :disabled="disabled || loading"
      >
      </date-range-picker>
    </div>
  </div>
</template>
